import React, { useState } from "react";
import { Button, Form, FormGroup, Input, Label } from "reactstrap";
import APIURL from "../../../helper/environment";

const CreateLot = (props) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [streetAddress, setStreetAddress] = useState("");
  const [cityAddress, setCityAddress] = useState("");
  const [stateAddress, setStateAddress] = useState("");
  const [zipcodeAddress, setZipcodeAddress] = useState("");
  const [contactPhoneNumber, setContactPhoneNumber] = useState("");
  const [totalParkingSpots, setTotalParkingSpots] = useState(0);
  const [availableParkingSpots, setAvailableParkingSpots] = useState(0);

  async function addParkingLot(e) {
    e.preventDefault();
    const url = `${APIURL}/parking-lot/add`;
    const bodyObject = {
      name: name,
      description: description,
      streetAddress: streetAddress,
      cityAddress: cityAddress,
      stateAddress: stateAddress,
      zipcodeAddress: zipcodeAddress,
      contactPhoneNumber: contactPhoneNumber,
      totalParkingSpots: totalParkingSpots,
      availableParkingSpots: availableParkingSpots,
    };

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", props.token);

    const requestOptions = {
      headers: myHeaders,
      method: "POST",
      body: JSON.stringify(bodyObject),
    };

    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      console.log(data);
      props.getAllLots();
    } catch (error) {
      console.error(error.message);
    }
  }

  return (
    <>
      <Form
        className="mbsc-col-12 mbsc-col-md-6 mbsc-col-lg-3"
        onSubmit={addParkingLot}
      >
        <h3>Add a new Parking Lot</h3>
        <FormGroup>
          <Label>Name:</Label>
          <Input
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label>Description:</Label>
          <Input
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label>Street Address:</Label>
          <Input
            type="text"
            value={streetAddress}
            onChange={(e) => setStreetAddress(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label>City:</Label>
          <Input
            type="text"
            value={cityAddress}
            onChange={(e) => setCityAddress(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label>State:</Label>
          <Input
            type="text"
            value={stateAddress}
            onChange={(e) => setStateAddress(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label>Zipcode:</Label>
          <Input
            type="number"
            value={zipcodeAddress}
            onChange={(e) => setZipcodeAddress(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label>Phone Number:</Label>
          <Input
            type="tel"
            value={contactPhoneNumber}
            onChange={(e) => setContactPhoneNumber(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label>Total Parking Spots:</Label>
          <Input
            type="number"
            value={totalParkingSpots}
            onChange={(e) => setTotalParkingSpots(e.target.value)}
          />
        </FormGroup>

        <FormGroup>
          <Label>Available Parking Spots:</Label>
          <Input
            type="number"
            value={availableParkingSpots}
            onChange={(e) => setAvailableParkingSpots(e.target.value)}
          />
        </FormGroup>

        <div className="d-grid gap-2">
          <Button type="submit" color="success">
            Add New Parking Lot
          </Button>
        </div>
      </Form>
    </>
  );
};

export default CreateLot;
